import { inject } from '@angular/core';
import { Router } from '@angular/router';
import { Store } from '@ngrx/store';
import { selectRequiredToLogin } from '@us/web/shop/data-access';

export const checkAllowLoginGuard = async () => {
    const router = inject(Router);
    const store = inject(Store);
    const allowLogin = store.selectSignal(selectRequiredToLogin)();
    if (!allowLogin) {
        await router.navigateByUrl('/');
    }
    return allowLogin;
};
